import React from 'react'
import Link from 'gatsby-link'

const SecondPage = () => (
  <div>
    <div className='Instruction'>
      <div className='InstructionGroup'>
        <h1>Introduction</h1>
        <p>* Our research project aims at teaching people how gender bias is introduced and can be mitigated from AI systems. 
	Participants will interactively implement fair AI models in terms of gender. This lab is about AI-based autocomplete. 
	<br></br><br></br>* You will be guided through the following steps:
    
        </p>
        <h2>
          STEP1: Learn about gender bias in autocomplete<br></br>
	STEP2: Acquire data for training<br></br>
	STEP3: Learn about Markov language model<br></br>
	STEP4: Clean acquired data<br></br>
	STEP5: Postprocess stereotypical autocompleted expressions<br></br>
        </h2>
        <Link to="/">Back</Link>	
        <Link to="/1-bias/">Next step</Link>	
        <Link to="/">Go back to the homepage</Link>
      </div>
    </div>
  </div>
)

export default SecondPage



// WEBPACK FOOTER //
// ./src/pages/0-introduction.js